import { styled } from "@mui/material/styles";
import MuiBottomNavigation from "@mui/material/BottomNavigation";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";

/** Height of bottom navigation bar */
export const BOTTOM_NAV_HEIGHT = 64;

/**
 * Styled bottom navigation container with safe area support for notched devices.
 */
export const StyledBottomNavigation = styled(MuiBottomNavigation)(
  ({ theme }) => ({
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: BOTTOM_NAV_HEIGHT,
    zIndex: theme.zIndex.appBar,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    // Safe area padding for notched devices (iPhone X+)
    paddingBottom: "env(safe-area-inset-bottom, 0px)",
    // Adjust height when safe area is present
    "@supports (padding-bottom: env(safe-area-inset-bottom))": {
      height: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
    },
  }),
);

/**
 * Styled navigation action with touch-friendly sizing.
 */
export const StyledBottomNavigationAction = styled(MuiBottomNavigationAction)(
  ({ theme }) => ({
    minWidth: 64,
    padding: "6px 12px 8px",
    // Ensure touch target is at least 48px
    minHeight: 48,
    "& .MuiBottomNavigationAction-label": {
      fontSize: "0.75rem",
      marginTop: 4,
      "&.Mui-selected": {
        fontSize: "0.75rem",
      },
    },
    "& .MuiSvgIcon-root, & svg": {
      fontSize: 24,
      width: 24,
      height: 24,
    },
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  }),
);
